$(() => {
	//	IFrame patchfor the Youtube videos already used
    $('.rich-text iframe[src*=youtube]:not(.video-container iframe)')
        .wrap('<div class="video-container"></div>');
	$('.rich-text iframe[src*=youtube]').each(function() {
		var txtWidth = $(this).css('--iframe-width');
		if (txtWidth) {
			$(this).parent('.video-container').css('max-width', txtWidth);
			var pxHeight = Math.ceil($(this).width() * 0.5625);
			$(this).parent('.video-container').css('padding-bottom', pxHeight + 'px');
		}
	});		

	//	YouTube Bloc - YTBlock
	$('.ytblock .video-container iframe[src*=youtube]').each(function() {
		var txtWidth = $(this).css('--iframe-width');
		if (txtWidth) {
			var pxHeight = Math.ceil(parseFloat(txtWidth) * 0.52);
			$(this).parent('.video-container').css('max-width', txtWidth);
			$(this).parent('.video-container').css('padding-bottom', pxHeight + '%');
		}
	});
});
